import { withDependencies } from '@wix/thunderbolt-ioc'
import { ImageZoomAPISymbol, IMAGE_ZOOM_ID } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { ImageZoomHandlers, ImageZoomAPI } from '../types'
import { ComponentsStylesOverridesSymbol, IComponentsStylesOverrides } from '@wix/thunderbolt-symbols'

const imageZoomHandler = (
	zoomAPI: ImageZoomAPI,
	componentsStylesOverrides: IComponentsStylesOverrides
): IModelUpdatesHandlersImplementor<ImageZoomHandlers> => ({
	featureName: 'imageZoom',
	handlers: {
		closeImageZoom: ({ isImageZoomEnabled }) => {
			if (!isImageZoomEnabled) {
				zoomAPI.closeImageZoom()
			}
		},
		onMobileAndPreview: ({ isOnMobileAndPreview }) => {
			let height: string | null = null
			let position: string | null = null
			let top: string | null = null

			if (isOnMobileAndPreview) {
				height = '100vh'
				position = 'absolute'
				top = 'var(--blocked-site-scroll-margin-top)'
			}

			componentsStylesOverrides.update({
				[IMAGE_ZOOM_ID]: {
					'--image-zoom-height': height,
					'--image-zoom-position': position,
					'--image-zoom-top': top,
				},
			})
		},
	},
})

export const ImageZoomUpdateHandler = withDependencies(
	[ImageZoomAPISymbol, ComponentsStylesOverridesSymbol],
	imageZoomHandler
)
